import { Button, Group, Modal, Stack, Text, useMantineTheme } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'

interface CreateChannelConfirmationModalProps {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
}

export function CreateChannelConfirmationModal({ opened, onClose, onConfirm }: CreateChannelConfirmationModalProps) {
  const theme = useMantineTheme()
  return (
    <Modal.Root opened={opened} onClose={onClose} centered size="md">
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <IconAlertCircle
            size={24}
            style={{ minWidth: 24, color: 'var(--mantine-color-yellow-6)', marginRight: theme.spacing.xs }}
          />
          <Modal.Title fw={600}>Create a New Channel</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body pt="xs">
          <Stack gap="xl">
            <Text>
              Are you sure you want to create a new channel? It will <strong>not</strong> be connected to the current
              channel you are working on.
            </Text>

            <Group justify="flex-end" gap="sm">
              <Button variant="default" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={onConfirm}>Logout & Create Channel</Button>
            </Group>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
